import { userSettingsStore } from '@pascal/pascal-core/shared/core/store';

import './configureMobx';
import { setupResolution } from './setupResolution';
import { setupConfig } from './setupConfig';
import './setupHttpClient';
import { GAME_NAME } from '../constants/urls';
import { soundService } from '../../module/sound';

userSettingsStore.localStorageAndUserSettingsInit({ gameName: GAME_NAME, soundService: soundService });

setupResolution();
setupConfig();